import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { User } from 'src/app/models/users.model';
import { SharedService } from 'src/app/shared/services/shared.service';
import { NbToastrService, NbDialogService } from '@nebular/theme';
import { CurrencyCode } from 'src/app/models/country-code-mapper';

@Component({
  selector: 'app-payment-handler',
  templateUrl: './payment-handler.component.html',
  styleUrls: ['./payment-handler.component.scss'],
})
export class PaymentHandlerComponent implements OnInit {
  paymentPlanUid: string;
  user: User;
  loading = true;

  @ViewChild('dialog')
  dialog;

  constructor(
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ss: SharedService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
  ) {}

  async ngOnInit() {
    this.user = await this.ss.getUser();
    const queryParams = (await this.activatedRoute.queryParams.pipe(take(1)).toPromise()) as {
      id: string;
      resourcePath: string;
    };
    const params = (await this.activatedRoute.params.pipe(take(1)).toPromise()) as { paymentPlanUid: string; currencyCode: CurrencyCode };
    this.paymentPlanUid = params.paymentPlanUid;
    this.getPeachPaymentStatus(queryParams.id, params.currencyCode);
  }

  async getPeachPaymentStatus(paymentId, currency: CurrencyCode) {
    const d = this.dialogService.open(this.dialog, { closeOnEsc: false, closeOnBackdropClick: false });
    try {
      const res = (await this.http
        .post(`${environment.functionsRootUrl}/peach-getPaymentStatus/`, {
          paymentId: paymentId,
          planUid: this.paymentPlanUid,
          userUid: this.user.uid,
          currency: currency,
        })
        .toPromise()) as any;
      this.toastrService.success(`Your credits have been topped up!`, 'Success');
      console.log('Successfully added credits');
    } catch (error) {
      const errorCode = ((error.error || {}).result || {}).code || error.status;
      const errorText = ((error.error || {}).result || {}).description || (error.error || {}).message || '';
      this.toastrService.danger(
        `Failed to top up credits ${errorText ? `- ${errorText}` : ''}`,
        errorCode ? errorCode + ' Error' : 'Error',
        { duration: 15000 },
      );
      console.error(error);
    }
    d.close();
    this.router.navigate(['home/convert']);
  }
}
